import React from 'react'
import { NavLink } from 'react-router-dom'

function NavItem({ text, icon, to, onClick, ...props }) {
  return (
    <li>
      <NavLink 
        aria-label='more'
        to={to} 
        onClick={onClick}
        style={{ display: "flex", justifyContent: "start", alignItems: "center" }}
        {...props}
      >
        {icon} {text}
      </NavLink>
    </li>
  )
}

export default NavItem